import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, HostListener, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { InvestmentFlowService } from '../../../core/services/Investment-flow/investment-flow.service';
import { AppLang, LanguageService } from '../../../core/services/Language/lang.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent {
  private readonly languageService = inject(LanguageService);

  isMobileMenuOpen = false;
  activeSection = 'hero';
  showInvestment = true;

  isLangOpen = false;
  currentLang: AppLang = 'ar';

  constructor(
    public flow: InvestmentFlowService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.showInvestment = this.router.url !== '/profile';
        this.isLangOpen = false;

        if (this.router.url === '/') this.activeSection = this.activeSection || 'hero';
        else this.activeSection = '';
      });

    this.currentLang = this.languageService.getLang();
  }

  toggleLang() {
    this.isLangOpen = !this.isLangOpen;
  }

  closeLang() {
    this.isLangOpen = false;
  }

  setLang(lang: AppLang) {
    this.languageService.setLang(lang);
    this.currentLang = lang;
    this.isLangOpen = false;
   this.isMobileMenuOpen = false;

  }

  startInvestment() {
    this.isMobileMenuOpen = false;
    this.flow.openStart();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.lang-toggle')) this.isLangOpen = false;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  navigateToSection(id: string) {
    this.isMobileMenuOpen = false;

    if (this.router.url !== '/') {
      this.router.navigateByUrl('/').then(() => setTimeout(() => this.scrollTo(id), 80));
    } else {
      this.scrollTo(id);
    }
  }

  private scrollTo(id: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    const el = document.getElementById(id);
    if (!el) return;

    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = id;
  }
}
